// extracted by mini-css-extract-plugin
export var active = "MainNav-module--active--12987";
export var arrow = "MainNav-module--arrow--fe86c";
export var arrowIcon = "MainNav-module--arrowIcon--49e7f";
export var arrowRotated = "MainNav-module--arrowRotated--dd59b";
export var current = "MainNav-module--current--9077a";
export var dark = "MainNav-module--dark--1f90b";
export var icon = "MainNav-module--icon--6987e";
export var item = "MainNav-module--item--2c157";
export var light = "MainNav-module--light--90e8b";
export var link = "MainNav-module--link--1e744";
export var linkName = "MainNav-module--linkName--9a0d8";
export var list = "MainNav-module--list--5f959";
export var mainNav = "MainNav-module--mainNav--40cc7";
export var showSubMenu = "MainNav-module--showSubMenu--38c0e";
export var submenu = "MainNav-module--submenu--74154";
export var top = "MainNav-module--top--d3b44";
export var touchDisabled = "MainNav-module--touchDisabled--76aa3";